import { css } from "@vitality-ds/system";
export default css({
  padding: "$lg",
  display: "flex",
  flexDirection: "column",
  justifyContent: "stretch",
  alignItems: "stretch",
  flex: 1,
  overflow: "auto"
});